import React from 'react';

const ArrowRight = ({ height = 12, width = 12, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <title>triangle right</title>
    <g fill={color}>
      <path d="M2.783.088A.5.5,0,0,0,2,.5v11a.5.5,0,0,0,.268.442A.49.49,0,0,0,2.5,12a.5.5,0,0,0,.283-.088l8-5.5a.5.5,0,0,0,0-.824Z" fill={color}/>
    </g>
  </svg>
);

export default ArrowRight;
